// extracted by mini-css-extract-plugin
export default {"wrapper":"Gyj5HM","active":"BFuZk9","content":"cUvZxj"};